
import {
  NOTIFICACIONES_ADD,
} from '../../constants/sistemaNotificaciones/notificaciones.constants';

export const addNotificacion = (title, message) => ({
  type: NOTIFICACIONES_ADD,
  payload: { title, message },
});
